import { render, staticRenderFns } from "./IriImageUpload.vue?vue&type=template&id=32be3ddc"
import script from "./IriImageUpload.vue?vue&type=script&lang=js"
export * from "./IriImageUpload.vue?vue&type=script&lang=js"
import style0 from "./IriImageUpload.vue?vue&type=style&index=0&id=32be3ddc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports